import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handlePost } from '../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../common/inputfields/ErrorAwareTextField';

class CloseAndLinkToPartner extends Component {
    state = {
        errors: new Map(),
        linkedPartnerId: this.props.row.linkedPartnerId,
        linkedPartnerName: this.props.row.linkedPartnerName,
        linkedPartnerType: this.props.row.linkedPartnerType,
        comment: ''
    }
    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = this.props.path;
        const requestObject = {
            "transactionPrivateId": this.props.row.privateId,
            "partnerPrivateId": this.state.linkedPartnerId,
            "partnerType": this.state.linkedPartnerType,
            "comment": this.state.comment,
        };
        // console.log(requestObject);
        handlePost(path, requestObject, this);
    };

    render() {
        return (
            //todo: list proposed?
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                Linkelt partner neve: {this.state.linkedPartnerName}
                <div className='input-group'>
                    <ErrorAwareTextField
                        name="comment"
                        label="Újranyitás megjegyzés"
                        value={this.state.comment}
                        onChange={e => this.setState({ comment: e.target.value })}
                    />
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Eltávolítás és újranyitás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(CloseAndLinkToPartner);
